export const CHECK_SALES_FUNNEL_AVAILABILITY = "CHECK_SALES_FUNNEL_AVAILABILITY";
export const RESET_SALES_FUNNEL_DATA = "RESET_SALES_FUNNEL_DATA"
export const LOAD_FUNNEL_PAGE = "LOAD_FUNNEL_PAGE";
export const SAVE_FUNNEL_PAGE = "SAVE_FUNNEL_PAGE";